import { Stack, Box, Skeleton } from '@mui/material'

const HomeSkeleton = () => (
  <Stack direction="column" py={6} px={4} height="100%">
    <Box display="flex" justifyContent="center" marginBottom={8}>
      <Skeleton variant="rectangular" height={104} width={104} />
    </Box>

    <Stack direction="column" marginBottom={10}>
      <Skeleton variant="text" height={30} width="50%" />
      <Skeleton variant="text" height={30} />
    </Stack>

    <Skeleton variant="rectangular" height={40} />

    <Stack direction="row" spacing={2} justifyContent="space-between" marginTop={4}>
      <Skeleton variant="rectangular" height={40} width="50%" />
      <Skeleton variant="rectangular" height={40} width="50%" />
    </Stack>
  </Stack>
)

export default HomeSkeleton
